// extracted by mini-css-extract-plugin
export default {"menubtn":"MainMenu_menubtn__YVV4D"};